import React from "react";
import HeaderDownload from "../HeaderDownload/HeaderDownload";
import OptionsComponent from "../OptionsComponent/OptionsComponent";
import ChnLangPref from "../Profile/ChnLangPref";
import { optionsData } from "./constant";
import style from "./style.module.css";
import NotificationComponent from "./NotificationComponent";

const PostLoginView = ({ isPwaOpen, notifications = [] }) => {
  return (
    <div className={style["margin-top-negative"]}>
      {notifications.length ? (
        <NotificationComponent notifications={notifications} />
      ) : (
        <>{isPwaOpen ? "" : <HeaderDownload />}</>
      )}
      {/* <ChnLangPref /> */}
      <OptionsComponent optionsDataArray={optionsData} />
    </div>
  );
};
export default PostLoginView;
